import React, { useState } from 'react';

const HoverText = ({ children, placeholder = 'Hover me', className = '' }) => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <div
      className={className}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {isHovering ? children : placeholder}
    </div>
  );
};

export default HoverText;
